import { INPUT_METHOD } from '@atlaskit/editor-common/analytics';
export var InputSource = function (InputSource) {
  InputSource[InputSource["TOOLBAR"] = INPUT_METHOD.TOOLBAR] = "TOOLBAR";
  InputSource[InputSource["KEYBOARD"] = INPUT_METHOD.KEYBOARD] = "KEYBOARD";
  InputSource[InputSource["EXTERNAL"] = INPUT_METHOD.EXTERNAL] = "EXTERNAL";
  return InputSource;
}({});